/* istanbul ignore file */
export * from './shared-ao-components.module';
export { AoFooterComponent } from './ao-footer/ao-footer.component';
